import { ErrorHandler, LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import {registerLocaleData} from '@angular/common';
import {TranslateLoader, provideTranslateService} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {BrowserModule} from '@angular/platform-browser';
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import {Router} from '@angular/router';
import localeDE from '@angular/common/locales/de';
import {StepService} from '../services/step.service';
import {AdvisorSharedModule} from '../advisor.shared.module';
import {PortalService} from '../services/portal.service';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {SafeHtmlPipe} from "../pipe/SafeHtmlPipe";
import {PhotovoltaikcheckComponent} from "./photovoltaikcheck.component";
import {PhotovoltaikcheckRoutingModule} from "./photovoltaikcheck-routing.module";
import {EinstiegComponent} from "./einstieg/einstieg.component";
import {EingabeStepComponent} from "./eingabe/eingabe.step.component";
import {ErgebnisComponent} from "./ergebnis/ergebnis.component";
import {EingabeAusstiegComponent} from "./eingabe/eingabe.ausstieg.component";
import {EingabeRoofAreaComponent} from "./eingabe/eingabe.roof-area.component";
import {MatSliderModule} from "@angular/material/slider";
import {ErgebnisImageSolarComponent} from "./ergebnis/ergebnis.image-solar.component";
import {ErgebnisCostComponent} from "./ergebnis/ergebnis.cost.component";
import {ErgebnisHelpComponent} from "./ergebnis/ergebnis.help.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {FaqComponent} from "../faq/faq.component";
import {ErgebnisCompareComponent} from "./ergebnis/ergebnis.compare.component";
import {ErgebnisBalconyComponent} from "./ergebnis/ergebnis.balcony.component";
import {ErgebnisPriceComponent} from "./ergebnis/ergebnis.price.component";

// global definition of language prefix
declare let advisorTranslationPrefix;

// AoT requires an exported function for factories
export function HttpLoaderFactory() {
  const http = inject(HttpClient);
  return {
    getTranslation: (lang: string) => http.get<object>(
      (typeof advisorTranslationPrefix !== 'undefined' ? advisorTranslationPrefix : 'translations/' + PortalService.defaultPortal + '/stromcheck/') + lang + '.json'
    )
  };
}

// always load de locales for number formats
registerLocaleData(localeDE, 'de');

/**
 * returns the users locale from the browser
 */
function getBrowsersLocale() {
  /* tslint:disable:no-string-literal */
  if (navigator['browserLanguage']) {
    return navigator['browserLanguage'];
  }
  else if (navigator.language) {
    return navigator.language;
  }
  /* tslint:enable:no-string-literal */
}

@NgModule({
  declarations: [
    PhotovoltaikcheckComponent,
    EinstiegComponent,
    EingabeStepComponent,
    EingabeRoofAreaComponent,
    ErgebnisComponent,
    EingabeAusstiegComponent,
    SafeHtmlPipe,
    ErgebnisImageSolarComponent,
    ErgebnisCostComponent,
    ErgebnisHelpComponent,
    FaqComponent,
    ErgebnisCompareComponent,
    ErgebnisBalconyComponent,
    ErgebnisPriceComponent
  ],
  bootstrap: [
    PhotovoltaikcheckComponent
  ],
  imports: [
    BrowserModule,
    PhotovoltaikcheckRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    AdvisorSharedModule,
    MatCheckboxModule,
    MatSliderModule,
    MatExpansionModule
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
    {provide: LOCALE_ID, useValue: getBrowsersLocale()},
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
        dialogOptions: {
          user: {
            name: 'dummy',
            email: 'dummy@co2online.de'
          }
        }
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      const initializerFn = () => {
        inject(Sentry.TraceService)
      };
        return initializerFn();
      }),
    StepService,
        provideTranslateService({loader: {provide: TranslateLoader, useFactory: HttpLoaderFactory}}),
        provideHttpClient(withInterceptorsFromDi())
  ]
})
export class PhotovoltaikcheckModule {
}
